<template>
  <div
    id="confimration-modal"
    class="modal fade"
    data-backdrop="static"
    tabindex="-1"
    role="dialog"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content modal-borderless">
        <form>
          <div class="modal-header">
            <h4 class="modal-title">{{ title }}</h4>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="mb-2" v-html="message"></div>
          </div>
          <div class="modal-footer d-flex flex-wrap justify-content-between">
            <div class="text-small">
              <div v-if="monitor.visible" :class="monitor.type">
                {{ monitor.message }}
              </div>
            </div>
            <div class="d-flex ml-auto">
              <button
                type="button"
                class="btn btn-outline-secondary mr-1"
                data-dismiss="modal"
                aria-label="Close"
                 @click.stop.prevent="cancel"
              >
                {{$t('buttons.cancelButton')}}
              </button>
              <button class="btn btn-primary" @click.stop.prevent="confirm">{{$t('yes')}}</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: [],
  data() {
    return {
      title: null,
      message: null,
      data: {},
      event: null,
      next: null,
      monitor: {
        visible: false,
        message: null,
        type: "text-warning",
      },
    };
  },
  mounted() {
    let self = this;
    this.$bus.$on("confirmation-modal.show", (data) => {
      self.reset(data);
      self.title = data.title;
      self.message = data.message;
      self.data = data.data;
      self.event = data.event;
      // self.next = data.next;
      self.show();
    });

    this.$bus.$on("success-message", (data) => {
      this.monitor.visible = true;
      this.monitor.message = data.message || this.$t('deletedSuccessfully');
      this.monitor.type = "text-success";
      this.closeModal();
    });

    this.$bus.$on("error-message", (data) => {
      this.monitor.visible = true;
      this.monitor.message = data.message || this.$t('errors.serverError');;
      this.monitor.type = "text-danger";
      this.closeModal();
    });
  },
  methods: {
    show() {
      $("#confimration-modal").modal("show");
    },
    hide() {
      $("#confimration-modal").modal("hide");
    },
    confirm() {
      let self = this;
      let data = {};
      data = self.data;
      console.log(this.event + ".confirmed", data)
      this.$bus.$emit(this.event + ".confirmed", data);
      // data.next = self.next;
    },
    cancel() {
      this.closeModal()
      // let self = this;
      // let data = {};
      // data = self.data;
      // console.log(this.event + ".canceled", data)
      // this.$bus.$emit(this.event + ".canceled", data);
    },
    reset(data) {
      this.monitor.visible = false;
      this.monitor.message = null;
      this.monitor.type = "text-warning";
    },
    closeModal() {
      setTimeout(() => {
        this.monitor.visible = false;
        this.monitor.message = "";
        $("#confimration-modal").modal("hide");
      }, 1000);
    },
  },
};
</script>
